import styled from "styled-components";
import { Text } from "@ficatranquilo/contabilidade.com-ui";
import { escapeHtml } from "@components/ow";

// Select de pessoa (colaborador do Ponto, "Compartilhar com" de Documentos): o nome
// no campo, o nome e o e-mail (`hint`) no menu, e a busca nos dois.

const OptionText = styled.span`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

/** Sem acento e em minúsculas, para a busca do Select. */
const normalize = (text) =>
  String(text || "")
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase();

/** Busca no nome e no e-mail. */
export const searchLabelAndHint = (option, input) =>
  normalize(`${option.data.label} ${option.data.hint || ""}`).includes(normalize(input));

/** Menu com o nome e o e-mail; no campo, só o nome. */
export function labelWithHint(option, { context }) {
  if (context === "value" || !option.hint) return option.label;
  return (
    <OptionText>
      <Text $text={escapeHtml(option.label)} $variant="paragraph_small_medium" $color="N900" />
      <Text $text={escapeHtml(option.hint)} $variant="caption_medium" $color="N400" />
    </OptionText>
  );
}
